module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst media = model.media || {}\nconst mediaID = media.mediaID\nconst isImage = media.fileType === 'image'\nconst isFile = media.fileType === 'file'\nlet showPermissions = false\nlet permissionsTitles = false\nlet idTranslationKey = 'imageID'\nif(isFile){\nidTranslationKey = 'fileID'\n}\n// prepare usedPermissions\nlet usedPermissions = { read: true, write: true, }\nif(media.usedPermissions){\nusedPermissions = media.usedPermissions\n} else if(media.permissions){\nshowPermissions = helpers.hasAccessTo('cms_media:permissions:mimicOwner')\nusedPermissions = {\nread: \tutils.permissions.hasAccessTo(storage, media.permissions, 'read', scope, 'cms_media'),\nwrite: \tutils.permissions.hasAccessTo(storage, media.permissions, 'write', scope, 'cms_media'),\n}\n}\nif(showPermissions){\nconst owner = media.permissions.owner || {}\nconst auth = media.permissions.auth || {}\nconst public = media.permissions.public || {}\npermissionsTitles = {\nowner: `${owner.isServiceUser ? 'S' : 'L'}-${owner.userID || 0}`,\nauth: `${auth.read ? 'r' : '-'}${auth.write ? 'w' : '-'}`,\npublic: `${public.read ? 'r' : '-'}${public.write ? 'w' : '-'}`,\n}\n}\n%>\n<div>\n<%\nif(mediaID){\nif(config.isEnhanced && (thumb = (model.media || {}).thumb) && isImage){\n%>\n<div class=\"thumb\">\n<img src=\"<%= thumb %>\">\n</div>\n<%\n}\nif(!config.isEnhanced && showPermissions){\n%>\n<table class=\"permissions\">\n<tbody>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.permissions.owner') %>:</td>\n<td><div><%= permissionsTitles.owner %></div></td>\n</tr>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.permissions.auth') %>:</td>\n<td><div><%= permissionsTitles.auth %></div></td>\n</tr>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.permissions.public') %>:</td>\n<td><div><%= permissionsTitles.public %></div></td>\n</tr>\n<tr><td>&nbsp;</td></tr>\n<tr><td>&nbsp;</td></tr>\n</tbody>\n</table>\n<%\n}\n%>\n<table>\n<tbody>\n<tr>\n<td><%- storage.__(`mediaManagement.detailsSummary.${idTranslationKey}`) %>:</td>\n<td><%= model.media.mediaID %></td>\n</tr>\n<% if (usedPermissions.read !== false){ %>\n<% if (isImage){ %>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.resolution') %>:</td>\n<td><%= model.media.width %>x<%= model.media.height %></td>\n</tr>\n<% } %>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.size') %>:</td>\n<td><%= utils.fileSize.format(model.media.sizeInBytes, 2) %></td>\n</tr>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.createdAt') %>:</td>\n<td><%= utils.moment(model.media.createdAt).format('DD.MM.YYYY') %> um <%= utils.moment(model.media.createdAt).format('HH:mm') %> Uhr</td>\n</tr>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.name') %>:</td>\n<td><div class=\"largeContentHover\"><%= model.media.originalName %></div></td>\n</tr>\n<% if(config.isEnhanced && showPermissions){ %>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.permissions.owner') %>:</td>\n<td><div><%= permissionsTitles.owner %></div></td>\n</tr>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.permissions.auth') %>:</td>\n<td><div><%= permissionsTitles.auth %></div></td>\n</tr>\n<tr>\n<td><%- storage.__('mediaManagement.detailsSummary.permissions.public') %>:</td>\n<td><div><%= permissionsTitles.public %></div></td>\n</tr>\n<% } %>\n<% } %>\n</tbody>\n</table>\n<%\nif(usedPermissions.read !== false && utils.collectionSize(media.tags || []) > 0){\n%>\n<ul>\n<%\nfor(var t in media.tags){\n%><li><span><%= media.tags[t].name || 'UNKNOWN TAG' %></span><i class=\"fi fi-tag\"></i></li><%\n}\n%>\n</ul>\n<%\n}\n}\n%>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\mediaManagement\\mediaDetailsSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const media = model.media || {}
const mediaID = media.mediaID
const isImage = media.fileType === 'image'
const isFile = media.fileType === 'file'
let showPermissions = false
let permissionsTitles = false
let idTranslationKey = 'imageID'
if(isFile){
idTranslationKey = 'fileID'
}
// prepare usedPermissions
let usedPermissions = { read: true, write: true, }
if(media.usedPermissions){
usedPermissions = media.usedPermissions
} else if(media.permissions){
showPermissions = helpers.hasAccessTo('cms_media:permissions:mimicOwner')
usedPermissions = {
read: 	utils.permissions.hasAccessTo(storage, media.permissions, 'read', scope, 'cms_media'),
write: 	utils.permissions.hasAccessTo(storage, media.permissions, 'write', scope, 'cms_media'),
}
}
if(showPermissions){
const owner = media.permissions.owner || {}
const auth = media.permissions.auth || {}
const public = media.permissions.public || {}
permissionsTitles = {
owner: `${owner.isServiceUser ? 'S' : 'L'}-${owner.userID || 0}`,
auth: `${auth.read ? 'r' : '-'}${auth.write ? 'w' : '-'}`,
public: `${public.read ? 'r' : '-'}${public.write ? 'w' : '-'}`,
}
}

    ; __line = 33
    ; __append("\n<div>\n")
    ; __line = 35
    ; 
if(mediaID){
if(config.isEnhanced && (thumb = (model.media || {}).thumb) && isImage){

    ; __line = 38
    ; __append("\n<div class=\"thumb\">\n<img src=\"")
    ; __line = 40
    ; __append(escapeFn( thumb ))
    ; __append("\">\n</div>\n")
    ; __line = 42
    ; 
}
if(!config.isEnhanced && showPermissions){

    ; __line = 45
    ; __append("\n<table class=\"permissions\">\n<tbody>\n<tr>\n<td>")
    ; __line = 49
    ; __append( storage.__('mediaManagement.detailsSummary.permissions.owner') )
    ; __append(":</td>\n<td><div>")
    ; __line = 50
    ; __append(escapeFn( permissionsTitles.owner ))
    ; __append("</div></td>\n</tr>\n<tr>\n<td>")
    ; __line = 53
    ; __append( storage.__('mediaManagement.detailsSummary.permissions.auth') )
    ; __append(":</td>\n<td><div>")
    ; __line = 54
    ; __append(escapeFn( permissionsTitles.auth ))
    ; __append("</div></td>\n</tr>\n<tr>\n<td>")
    ; __line = 57
    ; __append( storage.__('mediaManagement.detailsSummary.permissions.public') )
    ; __append(":</td>\n<td><div>")
    ; __line = 58
    ; __append(escapeFn( permissionsTitles.public ))
    ; __append("</div></td>\n</tr>\n<tr><td>&nbsp;</td></tr>\n<tr><td>&nbsp;</td></tr>\n</tbody>\n</table>\n")
    ; __line = 64
    ; 
}

    ; __line = 66
    ; __append("\n<table>\n<tbody>\n<tr>\n<td>")
    ; __line = 70
    ; __append( storage.__(`mediaManagement.detailsSummary.${idTranslationKey}`) )
    ; __append(":</td>\n<td>")
    ; __line = 71
    ; __append(escapeFn( model.media.mediaID ))
    ; __append("</td>\n</tr>\n")
    ; __line = 73
    ;  if (usedPermissions.read !== false){ 
    ; __append("\n")
    ; __line = 74
    ;  if (isImage){ 
    ; __append("\n<tr>\n<td>")
    ; __line = 76
    ; __append( storage.__('mediaManagement.detailsSummary.resolution') )
    ; __append(":</td>\n<td>")
    ; __line = 77
    ; __append(escapeFn( model.media.width ))
    ; __append("x")
    ; __append(escapeFn( model.media.height ))
    ; __append("</td>\n</tr>\n")
    ; __line = 79
    ;  } 
    ; __append("\n<tr>\n<td>")
    ; __line = 81
    ; __append( storage.__('mediaManagement.detailsSummary.size') )
    ; __append(":</td>\n<td>")
    ; __line = 82
    ; __append(escapeFn( utils.fileSize.format(model.media.sizeInBytes, 2) ))
    ; __append("</td>\n</tr>\n<tr>\n<td>")
    ; __line = 85
    ; __append( storage.__('mediaManagement.detailsSummary.createdAt') )
    ; __append(":</td>\n<td>")
    ; __line = 86
    ; __append(escapeFn( utils.moment(model.media.createdAt).format('DD.MM.YYYY') ))
    ; __append(" um ")
    ; __append(escapeFn( utils.moment(model.media.createdAt).format('HH:mm') ))
    ; __append(" Uhr</td>\n</tr>\n<tr>\n<td>")
    ; __line = 89
    ; __append( storage.__('mediaManagement.detailsSummary.name') )
    ; __append(":</td>\n<td><div class=\"largeContentHover\">")
    ; __line = 90
    ; __append(escapeFn( model.media.originalName ))
    ; __append("</div></td>\n</tr>\n")
    ; __line = 92
    ;  if(config.isEnhanced && showPermissions){ 
    ; __append("\n<tr>\n<td>")
    ; __line = 94
    ; __append( storage.__('mediaManagement.detailsSummary.permissions.owner') )
    ; __append(":</td>\n<td><div>")
    ; __line = 95
    ; __append(escapeFn( permissionsTitles.owner ))
    ; __append("</div></td>\n</tr>\n<tr>\n<td>")
    ; __line = 98
    ; __append( storage.__('mediaManagement.detailsSummary.permissions.auth') )
    ; __append(":</td>\n<td><div>")
    ; __line = 99
    ; __append(escapeFn( permissionsTitles.auth ))
    ; __append("</div></td>\n</tr>\n<tr>\n<td>")
    ; __line = 102
    ; __append( storage.__('mediaManagement.detailsSummary.permissions.public') )
    ; __append(":</td>\n<td><div>")
    ; __line = 103
    ; __append(escapeFn( permissionsTitles.public ))
    ; __append("</div></td>\n</tr>\n")
    ; __line = 105
    ;  } 
    ; __append("\n")
    ; __line = 106
    ;  } 
    ; __append("\n</tbody>\n</table>\n")
    ; __line = 109
    ; 
if(usedPermissions.read !== false && utils.collectionSize(media.tags || []) > 0){

    ; __line = 111
    ; __append("\n<ul>\n")
    ; __line = 113
    ; 
for(var t in media.tags){

    ; __line = 115
    ; __append("<li><span>")
    ; __append(escapeFn( media.tags[t].name || 'UNKNOWN TAG' ))
    ; __append("</span><i class=\"fi fi-tag\"></i></li>")
    ; 
}

    ; __line = 117
    ; __append("\n</ul>\n")
    ; __line = 119
    ; 
}
}

    ; __line = 122
    ; __append("\n</div>")
    ; __line = 123
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\mediaManagement\mediaDetailsSummary.ejs

}